import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeWordEchos';
const args = {};

export class ModeWordEchos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
